import BlockHeader from '@pelckmans/elementis/components/blockheader';
import PinIcon from '@pelckmans/elementis/icons/pin';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PinnedMaterialContext from '../../_contexts/PinnedMaterialContext';
import PinnedMaterialCard from './PinnedMaterialCard';

export default function PinnedMaterialSection() {
  const { t } = useTranslation();

  const { pinnedMaterialList } = useContext(PinnedMaterialContext);

  if (pinnedMaterialList.length === 0) return null;

  return (
    <section className="pinned-material-section">
      <BlockHeader title={t('PAGES.TOC_LEVEL.PINNED_MATERIAL.TITLE')} titleTag="h2" icon={<PinIcon />} />
      <div className="pinned-material-container">
        {pinnedMaterialList.map(material => (
          <PinnedMaterialCard key={material.id} material={material} />
        ))}
      </div>
    </section>
  );
}
